import React, { useState } from 'react';
import { Box, Button, TextField } from '@material-ui/core';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { sendMessageAsync } from '../../common/CommonStore/CommonStoreSlice';

const SendMessage = () => {
  const [message, setMessage] = useState('');
  const dispatch = useDispatch();

  const handleSubmitMain = async () => {
    if (message === '') {
      toast.error('Message field should not empty!');
    } else {
      try {
        dispatch(
          sendMessageAsync({
            to: 'teenybeans.info@gmail.com',
            subject: 'New BCC Affiliate Marketing form filled up.',
            htmlBody:
              '<html><body><p>New BCC Affiliate Marketing form is filled up.</p><table><tr><th>Message:- </th><td>:- ' +
              message +
              '</td></tr></table></body></html>',
          })
        )
          .unwrap()
          .then((res) => {
            toast.success(`Message send successfully.`);
            setMessage('');
          })
          .catch((err) =>
            toast.error(
              'Unable to send Message, please try again in some time!'
            )
          );
      } catch (error) {
        toast.error('Unable to send Message, please try again in some time!');
      }
    }
  };

  return (
    <Box display="flex" pb={2} pt={2}>
      <Box flex={2}>
        <TextField
          placeholder="Write your query"
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <Box textAlign={'right'} mt={1}>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSubmitMain}>
            Send Message
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SendMessage;
